import { render, staticRenderFns } from "./Presentaciones.vue?vue&type=template&id=2139de63&scoped=true"
import script from "./Presentaciones.vue?vue&type=script&lang=js"
export * from "./Presentaciones.vue?vue&type=script&lang=js"
import style0 from "./Presentaciones.vue?vue&type=style&index=0&id=2139de63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2139de63",
  null
  
)

export default component.exports